// extracted by mini-css-extract-plugin
export default {"root":"O_3z-","small":"_1rtZI","normal":"_3TfkU"};